import type { LanguageSelectOption } from './LanguageSelect';
import type { LanguageEnum } from 'src/common/external/bambi-api/bambiApi';

const LANGUAGE_LABELS: Record<
  LanguageEnum,
  { label: string; nativeLabel: string }
> = {
  en: { label: 'English', nativeLabel: 'English' },
  es: { label: 'Spanish', nativeLabel: 'Español' },
};

export const languageOptions: LanguageSelectOption<LanguageEnum>[] = (
  Object.entries(LANGUAGE_LABELS) as [
    LanguageEnum,
    { label: string; nativeLabel: string },
  ][]
).map(([value, names]) => ({ value, ...names }));
